import React from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import UserService from '../../services/user.service';
import SubsiteService from '../../services/subsite.service';
import { useForm } from "react-hook-form";

const AddressModal = (props) => {
  const nameOptional = !!props.nameOptional;
  const isSubsiteAddress = !!props.isSubsiteAddress;
  const subsiteId = props.subsiteId;

  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      name: props.address?.name || "",
      street: props.address?.street || "",
      street2: props.address?.street2 || "",
      city: props.address?.city || "",
      state: props.address?.state || "",
      zipCode: props.address?.zipCode || "",
      id: props.address?.id
    },
  });

  const onSubmit = async (data) => {
    var newAddress;
    if (isSubsiteAddress) {
      await SubsiteService.addEditSubsiteAddress({
        id: data.id,
        name: data.name || "",
        street1: data.street,
        street2: data.street2,
        city: data.city,
        state: data.state,
        zip: data.zipCode
      }, subsiteId);
      newAddress = {
        id: data.id,
        name: data.name || "",
        street: data.street,
        street2: data.street2,
        city: data.city,
        state: data.state,
        zipCode: data.zipCode
      };
      // If creating, pick the matching address from the refreshed list
      if (!data.id) {
        const list = await SubsiteService.getSubsiteAddresses(subsiteId);
        const matches = (list.data || []).filter(a =>
          a.street === data.street &&
          a.city === data.city &&
          a.zipCode === data.zipCode &&
          (a.name || "") === (data.name || "")
        );
        if (matches.length > 0) {
          newAddress = matches[matches.length - 1];
        }
      }
    } else if (props.userId) {
      if (data.id) {
        newAddress = await UserService.updateAddressForUser({ ...data, userId: props.userId });
      } else {
        newAddress = await UserService.addAddressForUser({ ...data, userId: props.userId });
      }
    } else if (data.id) {
      newAddress = await UserService.updateAddress(data);
    } else {
      const response = await UserService.addAddress({
        name: data.name,
        street1: data.street,
        street2: data.street2,
        city: data.city,
        state: data.state,
        zip: data.zipCode
      });
      newAddress = response.data;
    }
    props.closeAddressModal(newAddress);
  }

  const isNew = !props.address?.id;

  const addressModalClose = () => {
    props.closeAddressModal();
  }

  return (
    <Modal show={props.show} onHide={addressModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>{isNew ? "Add Address" : "Update Address"}<br /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>Name{nameOptional ? " (optional)" : ""}</Form.Label>
            <input {...register("name", { required: !nameOptional })} /><br />
            {errors.name && <div className="error" >Name is required</div>}
            {nameOptional && (
              <Form.Text className="text-muted">
                Leave blank to use the ordering user&apos;s name as the ship-to name.
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group className="mb-3" controlId="street">
            <Form.Label>Street</Form.Label>
            <input {...register("street", { required: true })} /><br />
            {errors.street && <div className="error" >Street is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="street2">
            <Form.Label>Apt/Suite Number</Form.Label>
            <input {...register("street2", { required: false })} /><br />
          </Form.Group>
          <Form.Group className="mb-3" controlId="city">
            <Form.Label>City</Form.Label>
            <input {...register("city", { required: true })} /><br />
            {errors.city && <div className="error" >City is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="state">
            <Form.Label>State</Form.Label>
            <select
              name="state"
              {...register("state", { required: true })}
            >
              <option value="">Select a State</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            {errors.state?.type === 'required' && <div className="error" >State is required</div>}
          </Form.Group>

          <Form.Group className="mb-3" controlId="zipCode">
            <Form.Label>Zip Code</Form.Label>
            <input {...register("zipCode", { required: true, minLength: 5, maxLength: 10 })} /><br />

            {errors.zipCode?.type === 'required' && <div className="error" >Zip Code is required</div>}
            {(errors.zipCode?.type === 'minLength' || errors.zipCode?.type === 'maxLength') && <div className="error" >Zip Code should be 5 or 10 digits</div>}

          </Form.Group>
          <Modal.Footer>
            <Button variant="secondary" onClick={addressModalClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit(onSubmit)} type="submit">
              {isNew ? "Add Address" : "Update Address"}
            </Button>
          </Modal.Footer>
        </Form>


      </Modal.Body>
    </Modal >
  );
};

export default AddressModal;
